import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {ShareModule} from "@share/share.module";
import {GeolocalisationComponent} from "@components/admin/parametre/geolocalisation/geolocalisation.component";
import {NgModule} from "@angular/core";
import {GeolocalisationParamsComponent} from "@components/admin/parametre/geolocalisation/geolocalisation-params/geolocalisation-params.component";
import {GeographieService} from "@services/admin/geographie/geographie.service";
import {PreviewAlerteModule} from "@share/component/alerte/preview-alerte.module";

export const geolocalisationRoutes: Routes = [
    {
        path: 'GeolocalisationParams',
        component: GeolocalisationParamsComponent,
        canActivate: [AdminGuardProvider],
    },{
        path: '',
        pathMatch: 'full',
        redirectTo: 'GeolocalisationParams'
    },
    {
        path: '**',
        redirectTo: 'GeolocalisationParams'
    }];


@NgModule({
    imports: [
        ShareModule,
        PreviewAlerteModule,
    ],
    declarations: [
        GeolocalisationComponent,
        GeolocalisationParamsComponent,
    ],
    exports: [
        GeolocalisationComponent,
    ],
    providers: [
        GeographieService,
    ]
})
export class GeolocalisationModule {
}